<template>
  <div class="erstinfo">
    <header class="erstinfo__head">
      <div class="erstinfo__eyebrow">
        <span class="erstinfo__dot"></span>WaizmannVergleich / ERSTINFORMATION
      </div>
      <h2 class="erstinfo__title">
        Erstinformationen für Kunden
        <span class="erstinfo__powered">| powered by WaizmannPro</span>
      </h2>
      <p class="erstinfo__sub">
        Dieser Vergleich wird Ihnen von der WaizmannPro GmbH (unabhängiger
        Versicherungsmakler) zur Verfügung gestellt. Die Antragsabwicklung wird
        von der WaizmannPro GmbH durchgeführt. Ihre Daten werden nicht
        weitergegeben oder zu Werbezwecken verwendet.
      </p>
    </header>

    <section class="erstinfo__grid">
      <article class="ecard">
        <div class="ecard__eyebrow">GESCHÄFTSFÜHRUNG</div>
        <h3 class="ecard__title">WaizmannPro</h3>
        <p class="ecard__body">Ricarda Meier</p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">POSTANSCHRIFT</div>
        <h3 class="ecard__title">Adresse</h3>
        <p class="ecard__body">
          Ludwig-Ganghofer-Straße 6<br />
          82031 Grünwald
        </p>
        <p class="ecard__body">
          E-Mail: <a href="mailto:info@waizmannpro.de">info@waizmannpro.de</a>
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">VERMITTLERREGISTER</div>
        <h3 class="ecard__title">§ 34 d Abs. 1 GewO</h3>
        <p class="ecard__body">
          Die WaizmannPro GmbH ist Versicherungsmakler mit Erlaubnis,
          registriert unter <strong>IHK-Nr. D-WEFL-B1QD0-82</strong>.
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">BETEILIGUNGEN</div>
        <h3 class="ecard__title">Beteiligung an / von Versicherungsunternehmen</h3>
        <p class="ecard__body">
          Das Unternehmen besitzt keine direkten oder indirekten Beteiligungen
          oder Stimmrechte am Kapital eines Versicherungsunternehmens. Es besitzt
          auch kein Versicherungsunternehmen direkte oder indirekte Stimmrechte
          oder Beteiligungen am Kapital der WaizmannPro GmbH.
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">VERMÖGENSSCHADENHAFTPFLICHT</div>
        <h3 class="ecard__title">Berufshaftpflichtversicherung</h3>
        <p class="ecard__body">
          Eine den Bestimmungen der EU-Vermittlerrichtlinie entsprechende
          Berufshaftpflichtversicherung / Vermögensschadenhaftpflichtversicherung
          liegt vor (über Nassau Versicherungen).
        </p>
        <p class="ecard__body">
          <strong>Inhaltlich Verantwortlicher gemäß § 10 Abs. 3 MDStV:</strong>
          Florian Meier
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">AUFSICHTSBEHÖRDE</div>
        <h3 class="ecard__title">IHK München und Oberbayern</h3>
        <p class="ecard__body num">
          Max-Joseph-Str. 2<br />
          80333 München<br />
          Tel.: 089 5116-0<br />
          Fax: 089 5116-1306<br />
          E-Mail:
          <a href="mailto:info@muenchen.ihk.de">info@muenchen.ihk.de</a><br />
          Web:
          <a href="https://www.ihk-muenchen.de" target="_blank" rel="noopener">
            www.ihk-muenchen.de
          </a>
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">SCHLICHTUNGSSTELLE</div>
        <h3 class="ecard__title">BaFin</h3>
        <p class="ecard__body num">
          Graurheindorfer Straße 108, 53117 Bonn<br />
          Tel.: 0228 4108-0<br />
          Fax: 0228 4108-62299<br />
          E-Mail:
          <a href="mailto:schlichtungsstelle@bafin.de">
            schlichtungsstelle@bafin.de
          </a>
          <br />
          Web:
          <a href="https://www.bafin.de" target="_blank" rel="noopener">
            www.bafin.de
          </a>
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">SCHLICHTUNGSSTELLE</div>
        <h3 class="ecard__title">Versicherungsombudsmann e. V.</h3>
        <p class="ecard__body num">
          Postfach 080632, 10006 Berlin<br />
          Tel.: 0800 3696000<br />
          Fax: 0800 3699000<br />
          E-Mail:
          <a href="mailto:beschwerde@versicherungsombudsmann.de">
            beschwerde@versicherungsombudsmann.de
          </a>
          <br />
          Web:
          <a
            href="https://www.versicherungsombudsmann.de"
            target="_blank"
            rel="noopener"
          >
            www.versicherungsombudsmann.de
          </a>
        </p>
      </article>

      <article class="ecard">
        <div class="ecard__eyebrow">SCHLICHTUNGSSTELLE</div>
        <h3 class="ecard__title">
          Ombudsmann für die private Kranken- und Pflegeversicherung
        </h3>
        <p class="ecard__body num">
          Postfach 060222, 10052 Berlin<br />
          Tel.: 0800 2550444<br />
          Fax: 030 20458931<br />
          Web:
          <a href="https://www.pkv-ombudsmann.de" target="_blank" rel="noopener">
            www.pkv-ombudsmann.de
          </a>
        </p>
      </article>
    </section>
  </div>
</template>

<script>
  export default {
    name: "erst-info-pop",
    components: {},
  };
</script>

<style scoped>
  .erstinfo {
    width: 100%;
    padding: 16px 18px 22px;
    color: var(--wz-ink-2);
  }

  .erstinfo__head {
    background: #fff;
    border: 1px solid var(--wz-border);
    border-left: 3px solid var(--wz-blue);
    padding: 14px 16px;
    margin-bottom: 16px;
  }
  .erstinfo__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--wz-ink-4);
    display: flex;
    align-items: center;
  }
  .erstinfo__dot {
    width: 6px;
    height: 6px;
    background: var(--wz-blue);
    display: inline-block;
    margin-right: 8px;
  }
  .erstinfo__title {
    font-size: clamp(18px, 2.2vw, 22px);
    font-weight: 700;
    letter-spacing: -0.2px;
    color: var(--wz-ink);
    margin: 4px 0 4px;
    line-height: 1.2;
  }
  .erstinfo__powered {
    font-size: 14px;
    font-weight: 500;
    color: var(--wz-ink-5);
  }
  .erstinfo__sub {
    font-size: 13px;
    color: var(--wz-ink-3);
    line-height: 1.55;
    margin: 6px 0 0;
  }

  .erstinfo__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 10px;
  }

  .ecard {
    background: #fff;
    border: 1px solid var(--wz-border);
    border-left: 3px solid var(--wz-blue);
    padding: 12px 14px;
    border-radius: 3px;
  }
  .ecard__eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: var(--wz-ink-4);
  }
  .ecard__title {
    font-size: 15px !important;
    font-weight: 700;
    color: var(--wz-ink) !important;
    margin: 4px 0 6px;
    line-height: 1.25;
  }
  .ecard__body {
    font-size: 13px;
    color: var(--wz-ink-2);
    line-height: 1.55;
    margin: 0 0 6px;
  }
  .ecard__body:last-child {
    margin-bottom: 0;
  }
  .ecard__body a {
    color: var(--wz-blue);
  }
  .num {
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 780px) {
    .erstinfo {
      padding: 10px;
    }
    .erstinfo__head {
      padding: 10px 12px;
    }
    .erstinfo__title {
      font-size: 16px;
    }
    .erstinfo__grid {
      grid-template-columns: 1fr;
    }
    .ecard {
      padding: 10px 12px;
    }
  }
</style>
